const addSubscriptionToCartLineItemShowDropdown = (lineItemId, productId, lineitemidremovalid, t) => {
  let lineItemIdRe = Number(lineItemId);
  
  let formData = {
    items: [{
      quantity: 1,
      selling_plan: 4980211936,
      id: lineItemIdRe
    }]
  };
  let updates = {
    id: lineitemidremovalid,
    quantity: 0
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to update cart with changes');
    }
  }).then(() => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to add item to cart');
    }
  }).then(response => {
    const cartChangeEvent = new Event("cart:refresh");
    document.dispatchEvent(cartChangeEvent);
  }).catch(error => {
    console.error('An error occurred:', error);
  });
  
};

const updateCartItemWithSubscription = (lineItemId, productId, lineitemidremovalid, t, lineitemidsplit) => {
  //let addSubscriptionDropdown = t.parentElement.querySelector(".cart-add-subscription-dropdown");
  let addSubscriptionDropdown = document.querySelector("#"+t);
  let subscriptionPlanId = addSubscriptionDropdown.value;
  let lineItemIdRe = Number(lineItemId);
  let subscriptionPlanIdRe = Number(subscriptionPlanId);
  
  let formData = {
    items: [{
      quantity: 1,
      selling_plan: subscriptionPlanIdRe,
      id: lineItemIdRe
    }]
  };
  let updates = {
    id: lineitemidremovalid,
    quantity: 0
  }

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updates)
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to update cart with changes');
    }
  }).then(() => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to add item to cart');
    }
  }).then(res => {
    const cartChangeEvent = new Event("cart:refresh");
    document.dispatchEvent(cartChangeEvent);
  }).catch(error => {
    console.error('An error occurred:', error);
  });

};